export default __webpack_public_path__ + "static/media/597.a13c0e8e.jpg";